"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastMessege = exports.sendPrompt = exports.sendMessegeImages = exports.sendMessege = void 0;
const axios_1 = require("axios");
const moment_1 = __importDefault(require("moment"));
const apis_1 = require("../common/apis");
const error_1 = require("../common/error");
const interceptorsCached_1 = require("./interceptorsCached");
/**
 *
 * @param data
 * @returns
 */
const sendMessege = async (data) => {
    return new Promise(async (resolve, reject) => {
        await interceptorsCached_1.cachedAuthCall
            .post(apis_1.APP_CONSTANTS.messeges.send, data)
            .then(function (response) {
            const json = response;
            resolve(json);
        })
            .catch(function (error) {
            console.log("sendMessege error:", error);
            resolve(error);
        });
    });
};
exports.sendMessege = sendMessege;
/**
 *
 * @param data
 * @returns
 */
const getLastMessege = async (conversationId) => {
    return new Promise(async (resolve, reject) => {
        await interceptorsCached_1.cachedAuthCall
            .get(`${apis_1.APP_CONSTANTS.messeges.get}/${conversationId}?tst=${(0, moment_1.default)().unix()}&limit=1&offset=0&sort=DESC`)
            .then(function (response) {
            const json = response;
            resolve(json);
        })
            .catch(function (error) {
            console.log("get message error:", error);
            resolve(error);
        });
    });
};
exports.getLastMessege = getLastMessege;
/**
 *
 * @param data
 * @returns
 */
const sendMessegeImages = async (data) => {
    return new Promise(async (resolve, _reject) => {
        await interceptorsCached_1.cachedAuthCall
            .post(apis_1.APP_CONSTANTS.messeges.images, data).then(function (response) {
            const json = response;
            resolve(json);
        }).catch(function (error) {
            console.log("sendMessege error:", error);
            resolve(new error_1.RequestError(error, {
                reason: error.response?.status === axios_1.HttpStatusCode.Unauthorized
                    ? 'Session Out' : undefined
            }));
        });
    });
};
exports.sendMessegeImages = sendMessegeImages;
/**
 *
 * @param data
 * @returns
 */
const sendPrompt = async (data) => {
    return new Promise(async (resolve, reject) => {
        await interceptorsCached_1.cachedAuthCall
            .post(apis_1.APP_CONSTANTS.prompts.upload, data)
            .then(function (response) {
            const json = response;
            console.log('sendPrompt:', response);
            resolve(json);
        })
            .catch(function (error) {
            console.log("sendPrompt error:", error);
            resolve(error);
        });
    });
};
exports.sendPrompt = sendPrompt;
